import React, { useState } from "react";

const TrackData = () => {
  const [trackNumber, setTrackNumber] = useState("");
  const [trackData, setTrackData] = useState(null);
  const [error, setError] = useState(null);

  const handleTrack = async (e) => {
    e.preventDefault(); // Prevent page reload

    setTrackData(null);
    setError(null);

    if (!trackNumber.trim()) {
      setError("Please enter a valid Track ID.");
      return;
    }

    try {
      const response = await fetch(
        "https://goodwayattestation.com/crm/api/get-track-data",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ track_no: trackNumber }),
        }
      );

      const text = await response.text(); // Parse raw text
      let data;

      try {
        data = JSON.parse(text);
      } catch (err) {
        throw new Error("Invalid response from server.");
      }

      const requiredFields = ["track_no", "customer_name", "date"];
      const isValid = requiredFields.every(
        (field) => data[field] && data[field].trim() !== ""
      );

      if (!isValid) {
        throw new Error("Incomplete data. Please check your Track ID.");
      }

      setTrackData(data);
      setTrackNumber(""); // Clear input
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "auto", textAlign: "center" }}>
      <h2>Track your application status</h2>
      <p>You will be able to track your order by using the form below.</p>

      <form onSubmit={handleTrack}>
        <input
          type="text"
          value={trackNumber}
          placeholder="Enter Track ID"
          required
          onChange={(e) =>
            setTrackNumber(e.target.value.replace(/[^0-9]/g, ""))
          }
          style={{ padding: "10px", width: "60%", marginBottom: "10px" }}
        />
        <button type="submit" style={{ padding: "10px" }}>
          Track
        </button>
      </form>

      {error && <div style={{ color: "red", fontSize: "18px", marginTop: "10px" }}>{error}</div>}

      {trackData && (
        <table style={{ marginTop: "20px", width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#009bff", color: "white" }}>
              <th>Track Number</th>
              <th>Customer Name</th>
              <th>Date</th>
              <th>Attestation Type</th>
              <th>Apostille</th>
              <th>Apostille Yes</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{trackData.track_no}</td>
              <td>{trackData.customer_name}</td>
              <td>{trackData.date}</td>
              <td>{trackData.attestation_type || "N/A"}</td>
              <td>{trackData.apostille || "N/A"}</td>
              <td>{trackData.apostille_yes || "N/A"}</td>
              <td>{trackData.status || "N/A"}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TrackData;
